import React, { useCallback, useState } from "react";
import { useTrapSkuStore } from "../../stores/trapSkuStore";
import { useTrapsSelectionStore } from "../../stores/trapsSelectionStore";
import TrapSkuTableHeader from "./TrapSkuTableHeader";
import TrapSkuTableRow from "./TrapSkuTableRow";
import { TrapProductInlineRow, LoadingInlineRow } from "./TrapProductsRow";
import { ImageModal } from "components";

// Компонент для відображення таблиці сторінки "Товари ловушок"
const TrapSkuTable = React.memo(() => {
  // Отримуємо дані та дії зі стору ловушок
  const trapSkus = useTrapSkuStore((state) => state.trapSkus);
  const trapCategories = useTrapSkuStore((state) => state.trapCategories);
  const expandedTraps = useTrapSkuStore((state) => state.expandedTraps);

  const isSelectionModeActive = useTrapsSelectionStore(
    (state) => state.isSelectionModeActive,
  );
  // 10 колонок + 1 чекбокс вибору = 11
  const colSpan = isSelectionModeActive ? 11 : 10;

  // Локальне стан для відображення модального вікна зображення
  const [selectedImage, setSelectedImage] = useState(null);

  // Обробник кліку по мініатюрі зображення
  const handleImageClick = useCallback((imgUrl) => {
    if (!imgUrl) return;
    setSelectedImage(imgUrl);
  }, []);

  // Закриття модального вікна зображення
  const closeImageModal = useCallback(() => {
    setSelectedImage(null);
  }, []);

  return (
    <>
      <table id="trap-sku-table">
        <TrapSkuTableHeader />
        <tbody>
          {trapSkus.length === 0 ? (
            <tr>
              <td colSpan={colSpan} className="empty-row">
                Немає даних ловушок
              </td>
            </tr>
          ) : (
            trapSkus.map((item) => {
              const trapData = expandedTraps[item.sku];
              const isExpanded = !!trapData;

              return (
                <React.Fragment key={item.sku}>
                  <TrapSkuTableRow
                    item={item}
                    mappedCategories={trapCategories}
                    onImageClick={handleImageClick}
                  />
                  {/* Товари ловушки */}
                  {isExpanded && (
                    <>
                      {trapData.loading ? (
                        <LoadingInlineRow colSpan={colSpan} />
                      ) : (
                        trapData.products.map((product, idx) => (
                          <TrapProductInlineRow
                            key={product.product_sku}
                            product={product}
                            isSelectionModeActive={isSelectionModeActive}
                            isLast={idx === trapData.products.length - 1}
                            onImageClick={handleImageClick}
                          />
                        ))
                      )}
                    </>
                  )}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>
      <ImageModal
        isOpen={!!selectedImage}
        src={selectedImage}
        alt="Enlarged"
        onClose={closeImageModal}
      />
    </>
  );
});

export default TrapSkuTable;
